<ins-creator-action-panel
  title="Upload instructions"
  subtitle="Caption, hashtags and CTA for the creator."
  [(expanded)]="expanded">
  @if (shoutBrief(); as brief) {
    <dl class="m-0 grid grid-cols-1 gap-3 text-sm">
      @if (brief.suggestedCaption) {
        <div>
          <dt class="m-0 font-medium text-secondary">Suggested caption</dt>
          <dd class="m-0 mt-1 whitespace-pre-wrap text-primary">{{ brief.suggestedCaption }}</dd>
        </div>
      }
      @if (brief.suggestedHastags) {
        <div>
          <dt class="m-0 font-medium text-secondary">Suggested hashtags</dt>
          <dd class="m-0 mt-1 text-primary">{{ brief.suggestedHastags }}</dd>
        </div>
      }
      @if (brief.callToActionLink) {
        <div>
          <dt class="m-0 font-medium text-secondary">Call to action link</dt>
          <dd class="m-0 mt-1 break-all text-primary">
            <a [href]="brief.callToActionLink" target="_blank" rel="noopener noreferrer">
              {{ brief.callToActionLink }}
            </a>
          </dd>
        </div>
      }
      @if (!brief.suggestedCaption && !brief.suggestedHastags && !brief.callToActionLink) {
        <p class="m-0 text-sm text-secondary">No upload instructions were set on this brief.</p>
      }
    </dl>
  }
</ins-creator-action-panel>
